import { useEffect, useState } from 'react';

import { parseFromLocalStorage } from '@exchange-frontends/utils';

const useSelectedOrg = () => {
  const [selectedOrg, setSelectedOrg] = useState(() => parseFromLocalStorage('selectedOrg'));

  useEffect(() => {
    document.addEventListener('selectedOrgChange', (data) => {
      setSelectedOrg(data?.detail);
    });
    return () => {
      document.removeEventListener('selectedOrgChange', null);
    };
  }, []);

  return selectedOrg;
};

export default useSelectedOrg;
